module.exports = __webpack_public_path__ + "f1a16a73f1857587736a11f32f04cddb.jpg";